<template>
    <div>
        <div v-if="editHistory && editHistory.items.length > 0">
            <div class="history-card card" v-for="(item, index) in editHistory.items" :key="'history' + index">
                <p class="changes-title">{{$_getDateTimeFormat(item.changeTime)}} by {{(item.creatorUser||{}).userName || '-'}}</p>
                <div class="changes-container" v-for="(changes, changesIndex) in item.customFieldPropertyChanges" :key="'changes' + changesIndex">
                    <p v-if="changes.customFieldId" class="changes-field">{{(changes.customField||{}).name || '-'}}</p>
                    <p v-if="changes.fixedHeaderFieldId" class="changes-field">{{(changes.fixedHeaderField||{}).displayName || '-'}}</p>
                    <div>
                        <p class="changes-value ori-value">- &nbsp;&nbsp; {{changes.originalValue || ''}}</p>
                        <p class="changes-value new-value">+ &nbsp;&nbsp; {{changes.newValue || ''}}</p>
                    </div>
                </div>
                <p class="changes-datetime"></p>
            </div>
            <el-pagination
                :hide-on-single-page="false"
                :page-size="editHistoryApiParams.MaxResultCount"
                :total="editHistory.totalCount"
                @current-change="handleCurrentPageChange($event)"
                layout="prev, pager, next">
            </el-pagination>
        </div>
        <div v-else class="empty-history-container">
            <p>Edit History Not Found</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            editHistory: {
                type: Object
            },
            editHistoryApiParams: {
                type: Object
            }
        },
        data() {
            return {
                currentPage: null
            }
        },
        methods: {
            handleCurrentPageChange(val){
                this.currentPage = val || 1;
                var start = this.currentPage * this.editHistoryApiParams.MaxResultCount - this.editHistoryApiParams.MaxResultCount;
                this.$emit('handlePageChange', start)
            },
            // async getTableData() {
            //     var res = await customRecordingGetChangeHistory({ 'CustomRecordingId': this.detailInfo.id, 'Sorting': 'changeTime desc', ...this.apiParams })
            //     this.newHistoryInfo = res
            // }
        },
    }
</script>

<style lang="css" scoped>
.history-card {
    padding: var(--space-12);
    margin: var(--space-4) var(--space-4) var(--space-12) var(--space-4);
}
.changes-container {
    margin-bottom: var(--space-12);
}
.changes-title {
    border-bottom: 1px solid var(--section-line-grey);
    font-weight: 700;
    padding-bottom: var(--space-4);
    margin-bottom: var(--space-8);
    color: var(--main-color-1)
    
}
.changes-field {
    font-size: 14px;
    margin-bottom: var(--space-4);
    color: var(--main-color-1)
}
.changes-value {
    font-size: 12px;
    color: var(--description-grey);
    padding: var(--space-4) var(--space-12);
}
.ori-value {
    background-color: var(--changes-from);
}
.new-value {
    background-color: var(--changes-to)
};
.changes-datetime {
    margin: var(--space-4) 0;
    font-size: 12px;
    color: var(--description-grey);
}
.history-table{
    width: 100%
}
.history-table td, .history-table th{
    font-size: var(--description-size);
    padding: var(--space-2) var(--space-4);
}
.history-table td ul{
    padding-left: var(--space-4);
}
.history-table td ul li{
    margin: var(--space-4);
}
.empty-history-container {
    height: 200px;
    border: 1px dashed var(--section-line-grey);
    display: flex;
    justify-content: center;
    align-items: center;
}
.empty-history-container p {
    color: var(--description-grey);
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/changeHistoryTable.vue